export enum NonComplianceActionTypes {
  SET_NON_COMPLIANCE_UNRESOLVED_CASE_COUNT = "SET_NON_COMPLIANCE_UNRESOLVED_CASE_COUNT",
}
